export enum EventAgencyStatus {
  CREATE_NEW_AGENCY = <any>'CREATE_NEW_AGENCY',
  AGENCY_MAPPED = <any>'AGENCY_MAPPED',
  NONE = <any>'NONE'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/event-agency-status.enum.ts